// src/components/admin/AdminSidebar.jsx
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signOut } from '../../redux/features/authSlice';

const AdminSidebar = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <aside className="w-64 bg-gray-800 min-h-screen">
            <div className="flex flex-col h-full">
                <div className="p-4">
                    <h2 className="text-white text-xl font-semibold">Admin Dashboard</h2>
                </div>
                
                <nav className="flex-1 px-2 py-4">
                    <Link
                        to="/admin/dashboard"
                        className={`flex items-center px-4 py-2 mt-2 text-gray-100 rounded-lg ${
                            isActive('/admin/dashboard') ? 'bg-gray-700' : 'hover:bg-gray-700'
                        }`}
                    >
                        Dashboard
                    </Link>
                    <Link
                        to="/admin/blogs"
                        className={`flex items-center px-4 py-2 mt-2 text-gray-100 rounded-lg ${
                            isActive('/admin/blogs') ? 'bg-gray-700' : 'hover:bg-gray-700'
                        }`}
                    >
                        Manage Blogs
                    </Link>
                    <Link
                        to="/admin/ads"
                        className={`flex items-center px-4 py-2 mt-2 text-gray-100 rounded-lg ${
                            isActive('/admin/ads') ? 'bg-gray-700' : 'hover:bg-gray-700'
                        }`}
                    >
                        Manage Ads
                    </Link>
                    <Link
                        to="/admin/subscribers"
                        className={`flex items-center px-4 py-2 mt-2 text-gray-100 rounded-lg ${
                            isActive('/admin/subscribers') ? 'bg-gray-700' : 'hover:bg-gray-700'
                        }`}
                    >
                        Subscribers
                    </Link>
                </nav>

                <div className="p-4">
                    <button
                        onClick={() => dispatch(signOut())}
                        className="w-full px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700"
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </aside>
    );
};

export default AdminSidebar;
